import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatSubscriptionStatus(status: string): { text: string; variant: "default" | "secondary" | "destructive" | "outline" } {
  switch (status) {
    case 'active':
      return { text: 'Active', variant: 'default' }
    case 'trialing':
      return { text: 'Free Trial', variant: 'secondary' }
    case 'past_due':
    case 'past-due':
      return { text: 'Past Due', variant: 'destructive' }
    case 'canceled':
      return { text: 'Canceled', variant: 'secondary' }
    case 'incomplete':
      return { text: 'Incomplete', variant: 'destructive' }
    case 'incomplete_expired':
      return { text: 'Expired', variant: 'destructive' }
    case 'unpaid':
      return { text: 'Unpaid', variant: 'destructive' }
    default:
      //console.log('Unknown subscription status:', status)
      return { text: status.charAt(0).toUpperCase() + status.slice(1), variant: 'secondary' }
  }
}
